/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_CurrencyInputs */

const zh_pricing_currency = /** @type {(inputs: Pricing_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$`)
};

const en_pricing_currency = /** @type {(inputs: Pricing_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$`)
};

const es_pricing_currency = /** @type {(inputs: Pricing_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$`)
};

/**
* | output |
* | --- |
* | "$" |
*
* @param {Pricing_CurrencyInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_currency = /** @type {((inputs?: Pricing_CurrencyInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_CurrencyInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_currency(inputs)
	if (locale === "en") return en_pricing_currency(inputs)
	return es_pricing_currency(inputs)
});